import React, { createContext, useEffect, useState } from 'react';
import { CONSTANT } from '@const';
import { msalService } from '@services';
import { UserIdentityType } from '@types';
import { useLogout } from '@utils';

export interface UserIdentityContextState {
	accountLinked: boolean;
	setAccountLinked: (value: boolean) => void;
	userIdentity: UserIdentityType | undefined;
}
const contextDefaultValues: UserIdentityContextState = {
	accountLinked: false,
	setAccountLinked: () => {
		// do nothing
	},
	userIdentity: undefined,
};
export const UserIdentityContext = createContext<UserIdentityContextState>(contextDefaultValues);
export const UserIdentityContextProvider = ({ children }: { children: React.ReactNode }) => {
	const logout = useLogout();
	const [accountLinked, setAccountLinked] = useState<boolean>(contextDefaultValues.accountLinked);
	const [userIdentity, setUserIdentity] = useState<UserIdentityType | undefined>(
		contextDefaultValues.userIdentity,
	);
	useEffect(() => {
		setUserIdentity(msalService.getUserIdentity());
	}, []);

	useEffect(() => {
		if (accountLinked) {
			setTimeout(() => {
				logout();
			}, CONSTANT.AUTO_LOGOUT_TIMEOUT);
		}
	}, [accountLinked, logout]);

	return (
		<UserIdentityContext.Provider
			value={{
				accountLinked,
				setAccountLinked,
				userIdentity,
			}}
		>
			{children}
		</UserIdentityContext.Provider>
	);
};
